import { render } from "./Restaurants.vue?vue&type=template&id=61ffd6bf&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"

import "./Restaurants.vue?vue&type=style&index=0&id=61ffd6bf&lang=css"
import "./Restaurants.vue?vue&type=style&index=1&id=61ffd6bf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ffd6bf"]])

export default __exports__